/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Guide_Video_Not_VideoInputs */

const vi_error_shop_guide_video_not_video = /** @type {(inputs: Error_Shop_Guide_Video_Not_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File ở ô Video không phải video mp4 — hãy chọn file video.`)
};

/**

* @param {Error_Shop_Guide_Video_Not_VideoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_guide_video_not_video = /** @type {((inputs?: Error_Shop_Guide_Video_Not_VideoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Guide_Video_Not_VideoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_guide_video_not_video(inputs)
});